// Module
var code = `<div class="web-visualization-component" ng-show="currentHeight != 0"> <div class="loading-indicator fa-2x" ng-show="loading"> <i class="fa fa-refresh fa-spin"></i> </div> <div ng-class="{'hidden-content':loading}"> <iframe ng-style="{height:currentHeight + 'px'}" scrolling="no" ng-src="{{getFrameUrl()}}"></iframe> </div> </div>`;
// Exports
export default code;